export default {
  filters: {
    replace(value, target, replacement) {
      return value.replace(new RegExp(`/${target}/g`), replacement)
    },
  },
}
